import { Base } from "../../framework/base";
var IdTitle = /** @class */ (function () {
    function IdTitle(obj) {
        this.id = obj && obj.id || "";
        this.title = obj && obj.title || "";
    }
    IdTitle.createIdTitle = function (id, title) {
        var result = new IdTitle();
        result.id = id;
        result.title = title;
        return result;
    };
    IdTitle.createIdTitleSimple = function (text) {
        var result = new IdTitle();
        result.id = text;
        result.title = text;
        return result;
    };
    IdTitle.prototype.getTitle = function () {
        return this.title;
    };
    IdTitle.prototype.getHash = function () {
        return this.id + "#" + this.title;
    };
    IdTitle.getHash = function (items) {
        if (!items || items.length < 1)
            return "";
        return Base.joinSuffix(items.map(function (i) { return i.getHash(); }), "$");
    };
    IdTitle.equal = function (a, b) {
        if (!a && !b)
            return true;
        if (!a || !b)
            return false;
        if (a.length !== b.length)
            return false;
        for (var i = 0; i < a.length; i++) {
            if (a[i].getHash() !== b[i].getHash())
                return false;
        }
        return true;
    };
    IdTitle.getTitleById = function (items, id) {
        var _a;
        if (!items || items.length < 1)
            return "";
        var item = items.find(function (i) { return i.id === id; });
        return (_a = item === null || item === void 0 ? void 0 : item.title) !== null && _a !== void 0 ? _a : "";
    };
    IdTitle.sortIdTitles = function (items, asc) {
        if (!items && items.length < 2)
            return items;
        return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.getTitle(), b.getTitle())); });
    };
    return IdTitle;
}());
export { IdTitle };
